import React, { useEffect, useRef, useState } from 'react';
type Tab = {
  id: string;
  title: string;
  description: string;
  squareColor: string;
  iconUrl: string;
  assetUrl: string;
};
const TABS: Tab[] = [{
  id: 'visual-search',
  title: "Full design customization",
  description: "Every color, every layout, every card, every interaction \u2014 built to your brand.",
  squareColor: '#82D9F2',
  iconUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmnhj2ahv00de0z0y1cq7bf09/images/icon-4-thqsom2oh7a.png',
  assetUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/your-side-asset-1-pv9j68bytwj.png'
}, {
  id: 'shopper-memory',
  title: "User session inspector",
  description: "See every conversation the AI had \u2014 what it said, what shoppers asked, and what led to a sale.",
  squareColor: '#82D9F2',
  iconUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmnhj2ahv00de0z0y1cq7bf09/images/icon-5-e9fwnz458ni.png',
  assetUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/your-side-asset-2-qzidl0u98ve.png'
}, {
  id: 'virtual-try-on',
  title: "Built-in weekly insights",
  description: "Every week, a summary of what's working, what's not, and what to do next.",
  squareColor: '#82D9F2',
  iconUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/uploads/org_2REc1tnPEsPISxOixJ2l0CV1dpe/cmnhj2ahv00de0z0y1cq7bf09/images/icon-6-8ir5ylgo6i3.png',
  assetUrl: 'https://maker-devi-dev.s3-accelerate.amazonaws.com/user-files/org_2REc1tnPEsPISxOixJ2l0CV1dpe/your-side-asset-3-gn14nv2ptae.png'
}];
const AUTOPLAY_MS = 10000;
export const AIStorefrontMore2 = () => {
  const [windowWidth, setWindowWidth] = useState(() => typeof window !== 'undefined' ? window.innerWidth : 1440);
  const [active, setActive] = useState(0);
  const [hoveredTab, setHoveredTab] = useState<number | null>(null);
  const [inView, setInView] = useState(false);
  const timerRef = useRef<number | null>(null);
  const sectionRef = useRef<HTMLElement>(null);
  const isMobile = windowWidth <= 767;
  const isCompact = windowWidth <= 1024;
  const sidePad = isMobile ? '16px' : '24px';
  useEffect(() => {
    const onResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold: 0.2
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  const goTo = (idx: number) => {
    if (timerRef.current) window.clearTimeout(timerRef.current);
    setActive(idx);
  };
  useEffect(() => {
    const handler = (e: Event) => {
      const {
        section,
        tab
      } = (e as CustomEvent).detail;
      if (section === 'more-2') goTo(tab);
    };
    window.addEventListener('aisf-goto', handler);
    return () => window.removeEventListener('aisf-goto', handler);
  }, []);

  // Autoplay — desktop only
  useEffect(() => {
    if (!inView || isCompact) return;
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => {
      setActive(prev => (prev + 1) % TABS.length);
    }, AUTOPLAY_MS);
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, [active, inView, isCompact]);
  const toggleTab = (i: number) => setActive(prev => prev === i ? -1 : i);

  // ── Compact: accordion (mobile + tablet ≤1024px) ────────────────────────
  if (isCompact) {
    return <section id="aisf-more-2" ref={sectionRef} data-name="AI Storefront More 2" data-nav-theme="light" style={{
      backgroundColor: '#FCFAF6',
      paddingTop: 'clamp(60px, 8vw, 120px)',
      paddingBottom: 'clamp(60px, 8vw, 120px)'
    }}>
        <div style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: sidePad,
        paddingRight: sidePad
      }}>
          <h2 style={{
          fontSize: 'clamp(52px, 7vw, 92px)',
          lineHeight: 1.05,
          color: '#091717',
          margin: '0 0 32px 0',
          fontWeight: 400
        }}>
            <span style={{
            fontFamily: 'Instrument Sans, sans-serif',
            fontWeight: 400
          }}>More inside the{' '}</span>
            <span style={{
            fontFamily: 'Instrument Serif, serif',
            fontStyle: 'italic',
            fontWeight: 400,
            letterSpacing: '-0.02em'
          }}>AI Storefront</span>
          </h2>

          {TABS.map((tab, i) => {
          const isOpen = active === i;
          return <div key={tab.id} style={{
            borderTop: '1px solid rgba(9,23,23,0.12)'
          }}>
                <button type="button" onClick={() => toggleTab(i)} style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '20px 0',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              textAlign: 'left',
              fontFamily: 'Instrument Sans, sans-serif',
              color: '#091717',
              transition: 'background-color 200ms ease'
            }} data-tracking-id="btn-4345aa13ba489131">
                  <div style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '12px',
                opacity: isOpen ? 1 : 0.5,
                transition: 'opacity 200ms ease'
              }}>
                    <span aria-hidden="true" style={{
                  width: '40px',
                  height: '40px',
                  flexShrink: 0,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: isOpen ? tab.squareColor : 'rgba(9, 23, 23, 0.05)',
                  transition: 'background-color 200ms ease'
                }}>
                      <img src={tab.iconUrl} alt="" aria-hidden="true" style={{
                    width: '20px',
                    height: '20px',
                    objectFit: 'contain',
                    display: 'block'
                  }} />
                    </span>
                    <span style={{
                  fontSize: '20px',
                  fontWeight: 500,
                  letterSpacing: '-0.02em',
                  lineHeight: 1.3
                }}>
                      {tab.title}
                    </span>
                  </div>
                  <span aria-hidden="true" style={{
                fontSize: '24px',
                lineHeight: 1,
                flexShrink: 0,
                marginLeft: '16px',
                opacity: isOpen ? 1 : 0.4,
                transition: 'opacity 200ms ease'
              }}>
                    {isOpen ? '−' : '+'}
                  </span>
                </button>

                <div style={{
              maxHeight: isOpen ? '1200px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.4s ease'
            }}>
                  <div style={{
                paddingBottom: '24px'
              }}>
                    <p style={{
                  fontSize: '16px',
                  lineHeight: 1.5,
                  fontWeight: 400,
                  color: '#091717',
                  fontFamily: 'Instrument Sans, sans-serif',
                  margin: 0,
                  padding: '4px 0 20px'
                }}>
                      {tab.description}
                    </p>
                    <img src={tab.assetUrl} alt={tab.title} style={{
                  width: '100%',
                  height: 'auto',
                  display: 'block',
                  objectFit: 'cover'
                }} />
                  </div>
                </div>
              </div>;
        })}
          <div style={{
          borderTop: '1px solid rgba(9,23,23,0.12)'
        }} />
        </div>
      </section>;
  }

  // ── Desktop: 2-column slider ─────────────────────────────────────────────
  return <>
      <style>{`
        @keyframes aisfMoreProgressV2 {
          from { transform: scaleY(0); }
          to   { transform: scaleY(1); }
        }
      `}</style>

      <section id="aisf-more-2" ref={sectionRef} data-name="AI Storefront More 2" data-nav-theme="light" style={{
      backgroundColor: '#FCFAF6',
      paddingTop: 'clamp(60px, 8vw, 120px)',
      paddingBottom: 'clamp(60px, 8vw, 120px)'
    }}>
        <div style={{
        maxWidth: '1360px',
        margin: '0 auto',
        paddingLeft: sidePad,
        paddingRight: sidePad
      }}>
          <h2 style={{
          fontSize: 'clamp(52px, 7vw, 92px)',
          lineHeight: 1.05,
          color: '#091717',
          margin: '0 0 44px 0',
          fontWeight: 400
        }}><span style={{
            fontFamily: "'Instrument Serif', serif",
            fontStyle: 'italic'
          }}>Your side</span>{" of the store"}</h2>

          <div style={{
          display: 'flex',
          flexDirection: 'row',
          gap: '0',
          alignItems: 'stretch'
        }}>
            <div style={{
            flex: '0 0 50%',
            width: '50%',
            position: 'relative'
          }}>
              <div style={{
              position: 'relative',
              width: '100%',
              paddingBottom: '100%'
            }}>
                {TABS.map((tab, i) => <img key={tab.id} src={tab.assetUrl} alt={tab.title} style={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center',
                opacity: i === active ? 1 : 0,
                transition: 'opacity 600ms ease'
              }} />)}
              </div>
            </div>

            <div style={{
            flex: 1,
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column'
          }}>
              {TABS.map((tab, i) => {
              const isActive = i === active;
              const isHovered = hoveredTab === i;
              const showColor = isActive || isHovered;
              const opacity = isActive || isHovered ? 1 : 0.5;
              return <button key={tab.id} type="button" onClick={() => goTo(i)} onMouseEnter={() => setHoveredTab(i)} onMouseLeave={() => setHoveredTab(cur => cur === i ? null : cur)} aria-pressed={isActive} style={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                flex: 1,
                width: '100%',
                textAlign: 'left',
                border: 'none',
                cursor: 'pointer',
                backgroundColor: isActive ? '#F2F0E9' : 'transparent',
                padding: '32px 32px 32px 36px',
                fontFamily: 'Instrument Sans, sans-serif',
                color: '#091717',
                transition: 'background-color 200ms ease',
                overflow: 'hidden'
              }} data-tracking-id={`btn-aisf-more2_${tab.id}`}>
                    {isActive && inView && <span key={`more2-progress-${active}`} aria-hidden="true" style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  bottom: 0,
                  width: '2px',
                  backgroundColor: tab.squareColor,
                  transformOrigin: 'top center',
                  animation: `aisfMoreProgressV2 ${AUTOPLAY_MS}ms linear forwards`
                }} />}
                    <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  opacity,
                  transition: 'opacity 200ms ease',
                  marginBottom: '12px'
                }}>
                      <span aria-hidden="true" style={{
                    width: '40px',
                    height: '40px',
                    flexShrink: 0,
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: showColor ? tab.squareColor : 'rgba(9, 23, 23, 0.05)',
                    transition: 'background-color 200ms ease'
                  }}>
                        <img src={tab.iconUrl} alt="" aria-hidden="true" style={{
                      width: '20px',
                      height: '20px',
                      objectFit: 'contain',
                      display: 'block'
                    }} />
                      </span>
                      <div style={{
                    fontSize: '20px',
                    lineHeight: 1.3,
                    fontWeight: 500,
                    letterSpacing: '-0.02em'
                  }}>{tab.title}</div>
                    </div>
                    <div style={{
                  fontSize: '16px',
                  lineHeight: 1.5,
                  fontWeight: 400,
                  color: '#091717',
                  opacity,
                  transition: 'opacity 200ms ease'
                }}>
                      {tab.description}
                    </div>
                  </button>;
            })}
            </div>
          </div>
        </div>
      </section>
    </>;
};